import type { CareerPathCompensation, CareerPathSampleJobs } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (
  careerPathCompensations: CareerPathCompensation[],
  sampleJobs: CareerPathSampleJobs,
) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Earning Potential',
    description:
      'Compensation data across career tracks for this career path, including sample job titles and salary ranges.',
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Compensation Table',
    display:
      'Table showing salary ranges (entry-level, mid-career, late-career) grouped by career track tier, with sample job role chips per tier',
    data: { compensations: careerPathCompensations, sampleJobs },
  });
};
